/**
 * @todo - refactor strings usages with this path
 * */
export const qbPath = 'question_bank';
export const qbPathQuestions = 'question_bank/questions';
export const authoringPath = `/author/question`;
